module.exports = __webpack_public_path__ + "static/media/llantas-sin-asignar.0fd6ecfb.svg";